import moment from 'moment';

type numberType = "0" | "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9";
type monthDecaType = "0" | "1";
type dayDecaType = "0" | "1" | "2" | "3";
export type DateFormatType = `20${numberType}${numberType}-${monthDecaType}${numberType}-${dayDecaType}${numberType}`;

const dateFormat = 'yyyy-MM-DD';
const START_OF_TIME = '1900-01-01';
const END_OF_TIME = '2099-12-31';
const INFINITE_DAYS = toMomentsDatesRange({startDate: START_OF_TIME, endDate: END_OF_TIME});

export type DatesRange = {
  startDate: string;
  endDate: string;
}

export type MomentsDatesRange = {
  startDate: moment.Moment;
  endDate: moment.Moment;
}

function toMomentsDatesRange(dateRange: DatesRange): MomentsDatesRange {
  return {
    startDate: moment.utc(dateRange.startDate || START_OF_TIME, dateFormat),
    endDate: moment.utc(dateRange.endDate || END_OF_TIME, dateFormat),
  }
}

function fromMomentsDatesRange(dateRange: MomentsDatesRange): DatesRange {
  const result: DatesRange = {
    startDate: dateRange.startDate.format(dateFormat),
    endDate: dateRange.endDate.format(dateFormat),
  }
  return {
    startDate: result.startDate === START_OF_TIME ? '' : result.startDate,
    endDate: result.endDate === END_OF_TIME ? '' : result.endDate,
  }
}

/**
 * Clone and return a changed DatesRange[] that excludes a given datesRange
 * @param source
 * @param exclude
 * @param excludeEndDatesToo if true, the 2 dates in the exclude-dateRange will be excluded too
 */
export function excludeDatesRange(source: DatesRange[], exclude: DatesRange, excludeEndDatesToo = true): DatesRange[] {
  if (exclude.startDate === '' && exclude.endDate === '') {
    throw new Error('Exclusion range cannot be `always`');
  }
  if (source.length === 0) {
    source = [{startDate: '', endDate: ''}];
  }
  const momentSource = source.map(toMomentsDatesRange);
  const momentExclude = toMomentsDatesRange(exclude);

  // make exclusion range inclusive
  if (!excludeEndDatesToo) {
    momentExclude.startDate = exclude.startDate ? momentExclude.startDate.add(1, 'day') : momentExclude.startDate;
    momentExclude.endDate = exclude.endDate ? momentExclude.endDate.subtract(1, 'day') : momentExclude.endDate;
  }

  const ranges: MomentsDatesRange[] = [];

  momentSource.forEach(range => {
    if (range.startDate.isSameOrAfter(momentExclude.startDate) && range.startDate.isSameOrBefore(momentExclude.endDate)) {
      if (range.endDate.isAfter(momentExclude.endDate)) {
        //      rrrrrrrrr
        //    xxxxxxx
        // =    -----rrrr
        // remove first part of range, start with exclude.end + 1
        ranges.push({startDate: momentExclude.endDate.add(1, 'day'), endDate: range.endDate});
      } else {
        //      rrrrr
        //    xxxxxxx
        // =    -----
        // completely inside exclusion, do nothing
      }
    } else if (range.endDate.isSameOrBefore(momentExclude.endDate) && range.endDate.isSameOrAfter(momentExclude.startDate)) {
      //    rrr
      //     xxxxxxx
      // =  r--
        // remove last part of range, start with exclude.end + 1
        ranges.push({startDate: range.startDate, endDate: momentExclude.startDate.subtract(1, 'day')});
    } else if (range.endDate.isBefore(momentExclude.startDate) || (range.startDate.isAfter(momentExclude.endDate))){
      //   rrr
      //       xxx
      // = rrr
      // range outside of exclusion
      ranges.push(range);
    } else {
      //   rrrrrrrrr
      //      xxx
      // = rrr---rrr
      // range starts before exclusion and enddss after exclusion => make gap
      ranges.push({startDate: range.startDate, endDate: momentExclude.startDate.subtract(1, 'day')});
      ranges.push({startDate: momentExclude.endDate.add(1, 'day'), endDate: range.endDate});
    }
  });

  return ranges.map(fromMomentsDatesRange);
}

export function excludeTodayAndFuture(source: DatesRange[]): DatesRange[] {
  return excludeDatesRange(source, {startDate: moment.utc().format(dateFormat), endDate:''});
}
export function excludeFuture(source: DatesRange[]): DatesRange[] {
  return excludeDatesRange(source, {startDate: moment.utc().add(1, 'day').format(dateFormat), endDate:''});
}
